import { duration, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Box } from "../../Box";
import { InnerContainer } from "./InnerContainer";
export const StickyBox = styled(Box) `
  transition: all ${duration.animation.fast}ms ease-in-out;

  & ${InnerContainer} {
    padding-top: ${spacing.base.xl};
  }

  &.sticky {
    position: sticky;
    bottom: 0;
    backdrop-filter: blur(4px);
    background: rgba(240, 240, 240, 0.8);
    margin: 0 -${spacing.base.xl};
  }

  &.sticky.visible {
    padding: 0 ${spacing.base.xl} ${spacing.base.xl};

    & ${InnerContainer} {
      padding-top: 0;
      margin-top: ${spacing.base.xl};
    }
  }

  .compactMode &.sticky.visible {
    padding: 0 ${spacing.base.m} ${spacing.base.m};
    margin: 0 -${spacing.base.m};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RpY2t5Qm94LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRm9ybUFjdGlvblNlY3Rpb24vc3R5bGVkL1N0aWNreUJveC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQ0wsUUFBUSxFQUNSLE9BQU8sR0FDUixNQUFNLGdEQUFnRCxDQUFDO0FBQ3hELE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFDaEMsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBRWxELE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7b0JBQ2hCLFFBQVEsQ0FBQyxTQUFTLENBQUMsSUFBSTs7TUFFckMsY0FBYzttQkFDRCxPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7Ozs7Ozs7O2lCQVFqQixPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7Ozs7aUJBSWYsT0FBTyxDQUFDLElBQUksQ0FBQyxFQUFFLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxFQUFFOztRQUUzQyxjQUFjOztvQkFFRixPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7Ozs7O2lCQUtsQixPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsSUFBSSxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7aUJBQ2hDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQzs7Q0FFOUIsQ0FBQyJ9